export default "__VITE_ASSET__PqMs01X8__"